import { Col, Row, Button } from 'react-bootstrap';
import { useState, useEffect, useCallback } from 'react';

import ModalShell from '../common/modal-shell';
import BasicSpinner from '../common/basic-spinner';
import PaginatedList from '../common/pagination';

import { useAuth } from "../../utils/auth-provider";
import { fetchUserImages } from '../../utils/fetch-helpers'

import ImageCreateForm from '../image/image-create-form';

//================================================================

export default function ImagesPage(){

  const user = useAuth();

  const [images, setImages] = useState();
  const [modalShow, setModalShow] = useState(false);

  //----------------------------------------------------------------

  const fetchImages = async (signal) => {
    setImages( await fetchUserImages(user, signal));
  };

  //----------------------------------------------------------------

  const addImage = useCallback(async (image) => {
    setImages([...images, image]);
    setModalShow(false);
  }, [images]);

  //----------------------------------------------------------------

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    fetchImages(signal);

    return () => {
      // Cancel the request when the component unmounts
      abortController.abort();
    };
  }, []);

  //----------------------------------------------------------------

  return(
    <>
      {!images ?
        <BasicSpinner className="mb-4 col text-center" text={'Loading...'} />
        :
        <>
          <Row className="mb-3 align-items-center">
            <Col className="h4 my-0 text-start">Images:</Col>
            <Col className="text-end">
              <Button
                className="text-nowrap"
                onClick={() => setModalShow(true)}
              >
                Add New Image
              </Button>
            </Col>
          </Row>
          <PaginatedList
            key='user-images'
            list={images}
            type='image'
            isPrivate={true}
          />
        </>
      }

      <ModalShell
        title="Add New Image"
        show={modalShow}
        onHide={() => setModalShow(false)}
        hideFooter={true}
      >
        <ImageCreateForm
          onCancel={() => setModalShow(false)}
          onCreate={addImage}
        />
      </ModalShell>
    </>
  );
}
